<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bJcZSE/tc-custom/9780374708764.jpg?1737748006896" alt="This image is the cover for the book Farther Away"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Farther Away
      </h1>
      <p class="bookDescription body article font2">
        <b>The National Book Award–winning author of <i>Freedom</i> presents a “multifaceted and revealing collection” of essays (<i>The Economist</i>).</b><br/><br/>In <i>Farther Away</i>, which gathers together essays and speeches written mostly in the past five years, Franzen returns with renewed vigor to the themes, both human and literary, that have long preoccupied him. Whether recounting his violent encounter with bird poachers in Cyprus, examining his mixed feelings about the suicide of his friend and rival David Foster Wallace, or offering a moving and witty take on the ways that technology has changed how people express their love, these pieces deliver on Franzen’s implicit promise to conceal nothing.<br/><br/>On a trip to China to see first-hand the environmental devastation there, Franzen doesn’t omit mention of his excitement and awe at the pace of China’s economic development; the trip becomes a journey out of his own prejudice and moral condemnation. Taken together, these essays trace the progress of unique and mature mind wrestling with itself, with literature, and with some of the most important issues of our day.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jonathan Franzen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21aac8c4